<template>
	<CtaModal
		:open="open"
		:title="
			isStarted
				? t('extendedAccess.modal.startedTitle')
				: t('extendedAccess.modal.title', { days: ExtendedAccessDurationDays })
		"
		:message="
			isStarted
				? t('extendedAccess.modal.startedMessage', { days: ExtendedAccessDurationDays })
				: t('extendedAccess.modal.message')
		"
		:features="extendedAccessBenefits"
		:plain="isStarted"
		:confirm-label="isStarted ? t('extendedAccess.modal.startedConfirm') : t('extendedAccess.modal.start')"
		:dismiss-label="isStarted ? undefined : t('extendedAccess.modal.dismiss')"
		:confirm-disabled="extendedAccessStore.isStarting"
		@confirm="isStarted ? close() : start()"
		@dismiss="close"
	/>
</template>

<script setup lang="ts">
import { ref } from "vue"
import { useI18n } from "vue-i18n"
import CtaModal from "@/components/modals/CtaModal.vue"
import { useExtendedAccessBenefits } from "@/composables/useExtendedAccessBenefits"
import { useExtendedAccessStore } from "@/stores/extendedAccessStore"
import { useToastStore } from "@/stores/toastStore"
import type { CtaSource } from "@/utils/ctaSource"

const ExtendedAccessDurationDays = 30

const open = defineModel<boolean>("open", { required: true })
const props = defineProps<{ source: CtaSource }>()

const { t } = useI18n()
const extendedAccessStore = useExtendedAccessStore()
const toastStore = useToastStore()
const isStarted = ref(false)

const extendedAccessBenefits = useExtendedAccessBenefits()

function close(): void {
	open.value = false
	isStarted.value = false
}

async function start(): Promise<void> {
	if (await extendedAccessStore.start(props.source)) {
		isStarted.value = true
	} else {
		toastStore.error("extendedAccess.messages.startError")
	}
}
</script>
